import axios from 'axios'

import {apiBaseUrl} from '../config'

import {getLoginToken} from '../utils'

const BASE_URL = apiBaseUrl

async function get(path) {
  const userToken = getLoginToken()
  const resp = await axios.get(`${BASE_URL}${path}`, {
    headers: {Authorization: `Bearer ${userToken}`},
  })
  return resp
}

async function post(path, body, extraHeader = {}) {
  const userToken = getLoginToken()
  const resp = await axios.post(`${BASE_URL}${path}`, body, {
    headers: {Authorization: `Bearer ${userToken}`},
    ...extraHeader,
  })
  return resp
}

async function del(path) {
  const userToken = getLoginToken()
  const resp = await axios.delete(`${BASE_URL}${path}`, {
    headers: {Authorization: `Bearer ${userToken}`},
  })
  return resp
}

export {get, post, del}



// WEBPACK FOOTER //
// ./src/functions/requestUtils.js